import { noop } from "nodash"
import { createContext, FC, useContext } from "react"

export const BottomBarContext = createContext<{
    registerBottomBar: (config: BottomBarConfig) => void
    unregisterBottomBar: (key: string) => void
}>({ registerBottomBar: noop, unregisterBottomBar: noop })

export const useBottomBarRegistry = () => {
    return useContext(BottomBarContext)
}

export interface BottomBarConfig {
    Item: FC
    key: string
    cleanup?: () => void
    options?: { resizable?: boolean }
}
